import { useEffect, useState } from "react";
import { post } from "../networking/RequestService";

const useGetAttachments = (profileId) => {
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchAttachments = async () => {
        if (!profileId) return;

        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "getAttachments",
                profilId: profileId,
            });

            setAttachments(res.data.attachments || []);
        } catch (err) {
            setError(err);
            setAttachments([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAttachments();
    }, [profileId]);

    return { attachments, loading, error, refetch: fetchAttachments };
};

export default useGetAttachments;
